import * as React from "react";
import CryptoJS from "crypto-js";
import Box from "@mui/material/Box";
import MuiCard from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardContent from "@mui/material/CardContent";
import FormControl from "@mui/material/FormControl";
import RadioGroup from "@mui/material/RadioGroup";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import useGetCombSelect from "../../../../hooks/Consultas/useGetCombSelect";
import Skeleton from "../../../Kit/Skeleton/SkeletonCard";
import { useAuth } from "../../../Auth/AuthProtecter";


const Card = styled(MuiCard)(({ theme }) => ({
  border: "1px solid",
  borderColor: (theme.vars || theme).palette.divider,
  width: "100%",
  "&:hover": {
    background:
      "linear-gradient(to bottom right, hsla(210, 100%, 97%, 0.5) 25%, hsla(210, 100%, 90%, 0.3) 100%)",
    borderColor: "primary.light",
    boxShadow: "0px 2px 8px hsla(0, 0%, 0%, 0.1)",
    ...theme.applyStyles("dark", {
      background:
        "linear-gradient(to right bottom, hsla(210, 100%, 12%, 0.2) 25%, hsla(210, 100%, 16%, 0.2) 100%)",
      borderColor: "primary.dark",
      boxShadow: "0px 1px 8px hsla(210, 100%, 25%, 0.5) ",
    }),
  },
  [theme.breakpoints.up("md")]: {
    flexGrow: 1,
    maxWidth: `calc(50% - ${theme.spacing(1)})`,
  },
  variants: [
    {
      props: ({ selected }) => selected,
      style: {
        borderColor: (theme.vars || theme).palette.primary.light,
        ...theme.applyStyles("dark", {
          borderColor: (theme.vars || theme).palette.primary.dark,
        }),
      },
    },
  ],
}));

const dataSke = [
  {
    id: 1,
  },
  {
    id: 2,
  },
  {
    id: 3,
  },
];

const LST = process.env.REACT_APP_API_FRRS_LSTOREGE;
const secretKey = process.env.REACT_APP_SECRET_KEY_LOCALSTORAGE;
const loct = process.env.REACT_APP_STATELOCATION;

export default function AppointmentRequestState({ ...other }) {
  //
  //
  const auth = useAuth();
  //
  const [Url, setLoginUrl] = React.useState(auth.Domain);
  //
  //

  const optState = useGetCombSelect(Url, loct);

  const [paymentType, setPaymentType] = React.useState("creditCard");

  const handleNext = (stat) => {
    const state = { stat };
    sessionStorage.setItem(
      LST,
      CryptoJS.AES.encrypt(JSON.stringify(state), secretKey).toString()
    );
    other.setActiveStep(other.activeStep + 1);
  };

  return (
    <Stack spacing={{ xs: 3, sm: 6 }}>
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Typography variant="h6" gutterBottom>
          Seleccione un estado{" "}
        </Typography>
      </Box>
      <FormControl component="fieldset" fullWidth>
        <RadioGroup
          aria-label="Payment options"
          name="paymentType"
          value={paymentType}
          // onChange={handlePaymentTypeChange}
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            gap: 2,
          }}
        >
          {optState[0]
            ? optState.map((label) => (
                <Card key={label.id}>
                  <CardActionArea
                    onClick={() => handleNext(label)}
                    sx={{
                      ".MuiCardActionArea-focusHighlight": {
                        backgroundColor: "transparent",
                      },
                      "&:focus-visible": {
                        backgroundColor: "action.hover",
                      },
                    }}
                  >
                    <CardContent
                      sx={{ display: "flex", alignItems: "center", gap: 1 }}
                    >
                      🗺️
                      <Typography sx={{ fontWeight: "medium" }}>
                        {label.name}{" "}
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              ))
            : dataSke.map((da, i) => (
                <Card key={da.id}>
                  <Skeleton key={da.id} />
                </Card>
              ))}
        </RadioGroup>
      </FormControl>
    </Stack>
  );
}
